import { AuthenticationService } from '../../services/authentication.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { SessionService } from '../../services/session.service';
var NavbarComponent = (function () {
    function NavbarComponent(authService, sessionService, translate, router, apiService) {
        this.authService = authService;
        this.sessionService = sessionService;
        this.translate = translate;
        this.router = router;
        this.apiService = apiService;
        this.language = '';
        this.username = '';
        this.language = translate.currentLang;
    }
    NavbarComponent.prototype.ngOnInit = function () {
        var username = localStorage.getItem('username');
        this.username = username;
        this.toggleNav = true;
    };
    NavbarComponent.prototype.stopPropagation = function (event) {
        event.stopPropagation();
    };
    NavbarComponent.prototype.canUserSignDoc = function () {
        return this.authService.isAccountant();
    };
    NavbarComponent.prototype.changeLanguage = function (lang) {
        if (lang === 'en') {
            this.translate.use('en');
            localStorage.setItem('lang', 'en');
            this.sniff('CHANGE_LANG', 'en');
        }
        else if (lang === 'th') {
            this.translate.use('th');
            localStorage.setItem('lang', 'th');
            this.sniff('CHANGE_LANG', 'th');
        }
    };
    NavbarComponent.prototype.isAdmin = function () {
        return this.authService.isAdmin();
    };
    NavbarComponent.prototype.isClientAdmin = function () {
        return this.authService.isClientAdmin();
    };
    NavbarComponent.prototype.isUIH = function () {
        return this.authService.isUIH();
    };
    NavbarComponent.prototype.isAccountant = function () {
        return this.authService.isAccountant();
    };
    NavbarComponent.prototype.isAccountantAdmin = function () {
        return this.authService.isAccountantAdmin();
    };
    NavbarComponent.prototype.isIT = function () {
        return this.authService.isIT();
    };
    NavbarComponent.prototype.getUsername = function () {
        return localStorage.getItem('username');
    };
    NavbarComponent.prototype.getRole = function () {
        return localStorage.getItem('group');
    };
    NavbarComponent.prototype.logout = function () {
        var _this = this;
        this.apiService.logout().subscribe(function () {
            _this.router.navigate(['/login']);
            _this.sessionService.stop();
        });
        this.sniff('LOGOUT', this.username);
    };
    Object.defineProperty(NavbarComponent.prototype, "requireToChangePassword", {
        get: function () {
            return localStorage.getItem('require_to_change_password') === 'true';
        },
        enumerable: true,
        configurable: true
    });
    NavbarComponent.prototype.sniff = function (action, target) {
        var data = {
            action: action,
            address: 'HOME',
            target: target
        };
        this.apiService.sniff(data).subscribe(function (res) {
        });
    };
    return NavbarComponent;
}());
export { NavbarComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/core/navbar/navbar.component.ts.pre-build-optimizer.js